// extracted by mini-css-extract-plugin
module.exports = {"chatTextInput":"ChatTextInput_chatTextInput__31sLA","textInputBox":"ChatTextInput_textInputBox__1MY04","sendButtonText":"ChatTextInput_sendButtonText__3xwcW"};